import styles from './ResponsiveHeaderImage.module.scss'
import React from 'react'
// import CloudinaryImageSrcSet from '@/components/elements/media/CloudinaryImageSrcSet'
import CloudinaryImage from '@/components/elements/media/CloudinaryImage'
import ImageGradientOverlay from '@/components/elements/ImageGradientOverlay'
import mediaFileObject from '@/entities/mediaFile/interface'
import useBreakpoint from '@/hooks/useBreakpoint'

interface Props {
  image: mediaFileObject
  lazyload?: boolean // for better LCP, the initial visible image (e.g. first slider image) should not be lazy loaded
  withSidebar?: boolean // some pages have a sidebar. The image will be loaded in optimized aspect ratio
}

const versions = [
  { name: 'xs', height: 750, width: 576, defaultAspectRatio: undefined, sidebarAspectRatio: undefined },
  { name: 'sm', height: 750, width: 768, defaultAspectRatio: undefined, sidebarAspectRatio: undefined },
  { name: 'md', height: 800, width: 922, defaultAspectRatio: undefined, sidebarAspectRatio: undefined },
  { name: 'lg', height: 800, width: 1200, defaultAspectRatio: undefined, sidebarAspectRatio: 1.125 },
  { name: 'xl', height: 750, width: 1400, defaultAspectRatio: 1.777, sidebarAspectRatio: 1.315 },
  { name: 'xxl', height: 800, width: 1650, defaultAspectRatio: 1.777, sidebarAspectRatio: 1.6 },
  { name: 'fhd', height: 750, width: 1920, defaultAspectRatio: 1.777, sidebarAspectRatio: 1.821 },
  { name: 'uw', height: 750, width: 2560, defaultAspectRatio: 1.777, sidebarAspectRatio: 2.45 },
]

const isDefault = (currentBreakpoint: string | undefined, imageBreakpoint: string) => {
  if (currentBreakpoint) {
    return false
  }
  if (imageBreakpoint === 'xs') {
    return true
  }
}

const ResponsiveHeaderImageFull = ({ image, lazyload = false, withSidebar = false }: Props) => {
  const currentBreakpoint = useBreakpoint()
  return (
    <div className={styles.root}>
      {/*<CloudinaryImageSrcSet image={image} setOptions={buildSet(versions, withSidebar)} lazyload={lazyload} />*/}
      {versions.map((version, index: number) => {
        return (
          <React.Fragment key={index}>
            {(currentBreakpoint === version.name || isDefault(currentBreakpoint, version.name)) && (
              <CloudinaryImage
                key={index}
                image={image}
                height={!withSidebar && version.defaultAspectRatio ? undefined : version.height}
                width={withSidebar && version.sidebarAspectRatio ? undefined : version.width}
                aspectRatio={withSidebar && version.sidebarAspectRatio ? version.sidebarAspectRatio : version.defaultAspectRatio}
                lazyload={lazyload}
                responsive={false}
                placeholder={false}
              />
            )}
          </React.Fragment>
        )
      })}
      <ImageGradientOverlay />
    </div>
  )
}

export default ResponsiveHeaderImageFull
